<template src="./assettemplatechecks.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {},
    data() {
      return {
        FleetSubscription: {},
        CountAssetTemplateChecks: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        AssetChecks: [],
        TemplateID: 0,
        showCopyTemplatesPopup:false
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.TemplateID = this.$route.params.TemplateId;
      this.GetCompanySubscription();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },
    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
          this.GetAssetTemplateChecks();
        } else {
          this.$router.push("/settings");
        }
      },
      EnableEditMode() {
        this.Editmode = true;
      },
      DisableEditMode() {
        this.Editmode = false;
      },
      GetAssetTemplateChecks() {
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.TemplateChecks.List, {
          token: localStorage.getItem("token"),
          fleet_asset_template_id: this.TemplateID,
        }).then((Response) => {
          this.ShowLoader = false;
          this.AssetChecks = Response.data.AssetChecks;
          this.AssetChecks.forEach((element, index) => {
          if (this.AssetChecks[index]["description"]) {
            this.AssetChecks[index]["description"] = this.AssetChecks[
              index
            ]["description"].replaceAll(/(?:\\[rn])+/g, "");
          }

          if (element.required == 1) {
            this.AssetChecks[index]["required"] = true;
          } else {
            this.AssetChecks[index]["required"] = false;
          }
          
          if (element.photo_required == 1) {
            this.AssetChecks[index]["photo_required"] = true;
          } else {
            this.AssetChecks[index]["photo_required"] = false;
          }
          this.CountAssetChecks();
        });
        });
      },
      CountAssetChecks() {
        this.CountAssetTemplateChecks = this.AssetChecks.length;
      },
   
      SaveAssetCheck() {
        var error = false;
        this.AssetChecks.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Check Name", "", "error");
              return true;
            }
          }
        });
        if (!error) {
          this.Submitted = true;
          this.AssetChecks.fleet_asset_template_id = this.TemplateID;
          Axios.post(Endpoints.Assets.TemplateChecks.Create, {
            token: localStorage.getItem("token"),
            AssetChecks: this.AssetChecks,
          }).then((Response) => {
            this.Submitted = false;
            this.$swal(
              "Asset Check Saved Successfully",
              "",
              "success"
            ).then(() => {
              this.GetAssetTemplateChecks();
            });
          });
        }
      },
      DeleteCheck (checkid) {
        this.$swal({
          title: "Are you sure You want to delete this Check Record?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Assets.TemplateChecks.Delete, {
              token: localStorage.getItem("token"),
              id: checkid,
            }).then((Response) => {
              this.AssetChecks.forEach((value, index) => {
                if (value.id == checkid) {
                  this.AssetChecks.splice(index, 1);
                }
              });
              this.$swal(
                "Asset Check Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
                this.GetAssetTemplateChecks();
              });
            });
          }
        });
      },
      AddCustomAssetCheck() {
        if (
          this.FleetSubscription &&
          this.FleetSubscription.allowed_total_asset_checks >
            this.CountAssetTemplateChecks
        ) {
        this.Editmode = true;
        var obj = {
          custom: 1,
          id: 0,
          name: "",
          description: "",
          fleet_asset_template_id: this.TemplateID,
          position: this.AssetChecks.length + 1,
          required: 0,
          photo_required: 0,
          status: 1,
        };
        this.AssetChecks.push(obj);
        this.CountAssetChecks();
      }else {
          this.$swal(
            "You have reached your subscription's maximum allowed asset checks. Please contact us to add more checks",
            "",
            "error"
          );
        }
      },
    },
  };
</script>

<style type="text/css"></style>
